// import React, { useEffect, useRef, useState } from "react";

// function loadScript(url, callback) {
//   const script = document.createElement("script");
//   script.src = url;
//   script.async = true;
//   script.onload = callback;
//   document.body.appendChild(script);
// }

// function AddressAutocomplete({ formdata: parentFormData, onAddressChange }) {
//   const [query, setQuery] = useState(parentFormData.address);
//   const [formData, setFormData] = useState({
//     country: parentFormData.country || "",
//     state: parentFormData.state || "",
//     city: parentFormData.city || "",
//     address: parentFormData.address || "",
//     latitude: "",
//     longitude: "",
//     placeId: "",
//   });

//   const autoCompleteRef = useRef(null);
//   const inputRef = useRef(null);

//   useEffect(() => {
//     loadScript(
//       `https://maps.googleapis.com/maps/api/js?key=AIzaSyApd8SnCY_3LHinUXA84Pr4K0KxBWLKgj4&libraries=places`,
//       () => handleScriptLoad(setQuery, autoCompleteRef, setFormData)
//     );
//   }, []);

//   useEffect(() => {
//     setFormData({
//       country: parentFormData.country || "",
//       state: parentFormData.state || "",
//       city: parentFormData.city || "",
//       address: parentFormData.address || "",
//       latitude: "",
//       longitude: "",
//       placeId: "",
//     });
//     setQuery(parentFormData.address || "");
//   }, [parentFormData]);

//   const handleScriptLoad = (updateQuery, autoCompleteRef, setFormData) => {
//     autoCompleteRef.current = new window.google.maps.places.Autocomplete(
//       inputRef.current,
//       {
//         types: ["geocode"],
//         componentRestrictions: { country: "in" },
//       }
//     );

//     autoCompleteRef.current.addListener("place_changed", () =>
//       handlePlaceSelect(updateQuery, autoCompleteRef, setFormData)
//     );
//   };

//   const handlePlaceSelect = (updateQuery, autoCompleteRef, setFormData) => {
//     const place = autoCompleteRef.current.getPlace();
//     // console.log(place);
//     const addressComponents = place.address_components.reduce(
//       (acc, component) => {
//         const type = component.types[0];
//         if (type === "country") acc.country = component.long_name;
//         if (type === "administrative_area_level_1")
//           acc.state = component.long_name;
//         if (type === "locality") acc.city = component.long_name;
//         return acc;
//       },
//       {}
//     );

//     const updatedFormData = {
//       address: place.formatted_address,
//       latitude: place.geometry.location.lat(),
//       longitude: place.geometry.location.lng(),
//       placeId: place.place_id,
//       country: addressComponents.country || "",
//       state: addressComponents.state || "",
//       city: addressComponents.city || "",
//     };

//     setFormData(updatedFormData);
//     updateQuery(place.formatted_address);
//     onAddressChange(updatedFormData);
//   };

//   const handleInputChange = (event) => {
//     const { name, value } = event.target;
//     setFormData((prevData) => ({ ...prevData, [name]: value }));
//   };

//   return (
//     <div>
//       <input
//         className="w-full"
//         ref={inputRef}
//         value={query}
//         onChange={(event) => setQuery(event.target.value)}
//         placeholder="Search address..."
//         type="text"
//       />
//       {formData.address && (
//         <div style={{ marginTop: "10px" }}>
//           <div className="input-flex">
//             <div>
//               <label htmlFor="country">Country</label>
//               <input className="w-full"
//                 type="text"
//                 value={formData.country}
//                 readOnly
//               />
//             </div>
//             <div>
//               <label htmlFor="city">City</label>
//               <input
//                 className="w-full"
//                 type="text"
//                 value={formData.city}
//               // readOnly
//               />
//             </div>
//             <div>
//               <label htmlFor="state">State</label>
//               <input
//                 className="w-full"
//                 type="text"
//                 value={formData.state}
//               // readOnly
//               />
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default AddressAutocomplete;

import React, { useEffect, useRef, useState } from "react";
// import FormContainer from "../../../UI/FormContainer/FormContainer";
// import "./AddressAutoComplete.scss";

function loadScript(url, callback) {
  const existingScript = document.querySelector(`script[src="${url}"]`);
  if (!existingScript) {
    const script = document.createElement("script");
    script.src = url;
    script.async = true;
    script.onload = callback;
    document.body.appendChild(script);
  } else if (callback) {
    callback();
  }
}

function AddressAutocomplete({ formdata: parentFormData, onAddressChange }) {
  const [query, setQuery] = useState(parentFormData.address || "");
  const [formData, setFormData] = useState({
    country: parentFormData.country || "",
    state: parentFormData.state || "",
    city: parentFormData.city || "",
    address: parentFormData.address || "",
    latitude: "",
    longitude: "",
    placeId: "",
  });

  const autoCompleteRef = useRef(null);
  const inputRef = useRef(null);
  const isManualEdit = useRef(false); // Track if the user manually edits fields

  useEffect(() => {
    loadScript(
      `https://maps.googleapis.com/maps/api/js?key=AIzaSyApd8SnCY_3LHinUXA84Pr4K0KxBWLKgj4&libraries=places`,
      () => {
        if (window.google && window.google.maps) {
          autoCompleteRef.current = new window.google.maps.places.Autocomplete(
            inputRef.current,
            { types: ["geocode"] }
          );

          autoCompleteRef.current.addListener(
            "place_changed",
            handlePlaceSelect
          );
        }
      }
    );
  }, []);

  useEffect(() => {
    if (!isManualEdit.current) {
      setFormData({
        ...parentFormData,
        country: parentFormData.country || "",
        state: parentFormData.state || "",
        city: parentFormData.city || "",
        address: parentFormData.address || "",
        latitude: "",
        longitude: "",
        placeId: "",
      });
      setQuery(parentFormData.address || "");
    }
  }, [parentFormData]);

  const handlePlaceSelect = () => {
    const place = autoCompleteRef.current.getPlace();
    if (!place.geometry) return;

    const addressComponents = place.address_components.reduce(
      (acc, component) => {
        const type = component.types[0];
        if (type === "country") acc.country = component.long_name;
        if (type === "administrative_area_level_1")
          acc.state = component.long_name;
        if (type === "locality") acc.city = component.long_name;
        return acc;
      },
      {}
    );

    const updatedFormData = {
      address: place.formatted_address,
      latitude: place.geometry.location.lat(),
      longitude: place.geometry.location.lng(),
      placeId: place.place_id,
      country: addressComponents.country || "",
      state: addressComponents.state || "",
      city: addressComponents.city || "",
    };

    setFormData(updatedFormData);
    setQuery(place.formatted_address);
    isManualEdit.current = false; // Reset manual edit flag

    onAddressChange(updatedFormData);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: value };
      onAddressChange(updatedData); // Notify parent
      return updatedData;
    });

    isManualEdit.current = true;
  };

  return (
    <div>
      {/* <div>
        <label className="address_label">Address</label>
        <input
          className="custom_address"
          ref={inputRef}
          value={query}
          onChange={(event) => {
            setQuery(event.target.value);
            isManualEdit.current = true;
          }}
          placeholder="Search address..."
          type="text"
        />
      </div> */}

      <input
        className="w-full"
        ref={inputRef}
        value={query}
        onChange={(event) => {
          setQuery(event.target.value);
          setFormData((prevData) => {
            const updatedData = {
              ...prevData,
              address: event.target.value,
            };
            onAddressChange(updatedData); // Notify parent
            return updatedData;
          });
          isManualEdit.current = true;
        }}
        placeholder="Search address..."
        type="text"
      />

      {formData.address && (
        <div style={{ marginTop: "10px" }}>
          <div className="input-flex">

            <div>
              <label className="address_label">Country</label>
              <input
                className="w-full"
                type="text"
                name="country"
                value={formData.country}
                onChange={handleInputChange}
              // disabled
              />
            </div>
            <div>
              <label className="address_label">City</label>
              <input
                className="w-full"
                type="text"
                name="city"
                value={formData.city}
                onChange={handleInputChange}
              />
            </div>
            <div>
              <label className="address_label">State</label>
              <input
                className="w-full"
                type="text"
                name="state"
                value={formData.state}
                onChange={handleInputChange}
              // disabled
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AddressAutocomplete;